var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralRadiobuttonOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.625C5.28516 1.625 3.28906 2.80078 2.19531 4.6875C1.07422 6.60156 1.07422 8.92578 2.19531 10.8125C3.28906 12.7266 5.28516 13.875 7.5 13.875C9.6875 13.875 11.6836 12.7266 12.7773 10.8125C13.8984 8.92578 13.8984 6.60156 12.7773 4.6875C11.6836 2.80078 9.6875 1.625 7.5 1.625ZM7.5 14.75C4.98438 14.75 2.6875 13.4375 1.42969 11.25C0.171875 9.08984 0.171875 6.4375 1.42969 4.25C2.6875 2.08984 4.98438 0.75 7.5 0.75C9.98828 0.75 12.2852 2.08984 13.543 4.25C14.8008 6.4375 14.8008 9.08984 13.543 11.25C12.2852 13.4375 9.98828 14.75 7.5 14.75Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralRadiobuttonOff);
export default __webpack_public_path__ + "static/media/general-radiobutton-off.af8fd1a0e60ca5325edebf920c08e22e.svg";
export { ForwardRef as ReactComponent };